import { defineComponent as _defineComponent } from 'vue'
import { compile } from 'path-to-regexp'
import { onMounted, watch, ref, Ref } from 'vue'
import { RouteRecord } from 'vue-router'
import { useRoute, useRouter } from '@/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const breadcrumbs: Ref<RouteRecord[]> = ref([])
const router = useRouter()
const route = useRoute()
watch(route, () => {
  // if you go to the redirect page, do not update the breadcrumbs
  if (route.value.path.startsWith('/redirect/')) {
    return
  }
  getBreadcrumb()
})
onMounted(() => {
  getBreadcrumb()
})

function getBreadcrumb() {
  let matched = route.value.matched.filter(
    (item) => item.meta && item.meta.title
  )

  breadcrumbs.value = matched.filter((item) => {
    return item.meta && item.meta.title && item.meta.breadcrumb !== false
  })
}

function pathCompile(path: string) {
  // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
  const { params } = route.value
  const toPath = compile(path)
  return toPath(params)
}
function handleLink(item: any) {
  const { redirect, path } = item
  const currentRoutePath = route.value.path
  if (redirect) {
    if (redirect === currentRoutePath) return
    router?.push(redirect)
    return
  }
  if (path === currentRoutePath) return
  router?.push(pathCompile(path))
}

return { __sfc: true,breadcrumbs, router, route, getBreadcrumb, pathCompile, handleLink }
}

})